import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { UserService } from 'src/app/services/core/users/user.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';

@UntilDestroy()

@Component({
  selector: 'app-users-list',
  templateUrl: './users-list.component.html',
  styleUrls: ['./users-list.component.css']
})
export class UsersListComponent implements OnInit {
  companies:any
  users: any;
  search: any
  selectedStatus: any = true;
  filteredUsersList: any;
  preCompanies:any;
  selectedCompany:any = null;
  selectedFundingSource:any = null;
  filteredCompanyList:any;
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  status = true
  preFundingSource:any = {};
  preMembers:any = {};
  isInfo = false;
  // fundingSourceList: any;
  userPermission=UserPermission;
  filteredAssociationList: any;

  constructor(
    private userService: UserService,
    private credentialService: CredentialService,
    // private fundingSource: FundingSourceService,
    // private memberService: MemberService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.getCompanies();
    // this.getFundingSource();
    // this.getAllMembers();
    this.getAllUsers(this.currentPage);
  }

  getAllUsers(page:number){
    let queryParams = {
      limit : 50,
      sortBy : 'createdAt:desc',
      isActive: this.status,
      page,
    }
    this.userService.getUsers(queryParams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
      if (data && data.results ){
        this.users = data.results;
        this.users = data.results.sort((a: any, b: any) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        );
        this.filteredUsersList = [...this.users];
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
        this.filterUsers();
      }
    })
  }

  getCompanies() {
    const queryparams = {
      limit: 9999
    }
    this.credentialService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.companies = data.results;
          this.preCompanies = this.companies.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
        }
      })
  }

  // getFundingSource() {
  //   const queryparams = {
  //     limit: 9999
  //   }
  //   this.fundingSource.getPicker(queryparams).pipe(untilDestroyed(this)).subscribe((data: any) => {
  //     if (data && data.results ) {
  //       this.fundingSourceList = data.results;
  //       this.preFundingSource = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
  //     }
  //   })
  // }

  // getAllMembers(){
  //   const queryparams = {
  //     limit: 999
  //   }
  //   this.memberService.getMembers(queryparams).pipe(untilDestroyed(this)).subscribe((data:any)=>{
  //     if (data && data.results ){
  //      this.preMembers = data.results.reduce((obj: any, item: any) => (obj[item.id] = item, obj), {});
  //     }
  //   })
  // }

  openCloseInfo() {
    this.isInfo = !this.isInfo;
  }

  filterUsers() {
    this.filteredUsersList = this.users.filter((user: any) => {
      const matchCompany = this.selectedCompany ? user.company === this.selectedCompany.id : true;
      const matchFundingSource = this.selectedFundingSource ? user.fundingsource === this.selectedFundingSource.id : true;
      const matchStatus = this.selectedStatus !== undefined ? user.isActive === this.selectedStatus : true;
      return matchCompany && matchStatus && matchFundingSource;
    });
  }

  onSelectStatus() {
    this.status = this.selectedStatus;
    this.getAllUsers(this.currentPage = 1);
  }

  filterCompaniesBySelection() {
    this.selectedFundingSource = null;
    this.filterUsers();
  }

  filterFundingsourceBySelection() {
    this.selectedCompany = null;
    this.filterUsers();
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllUsers(page);
  }
}
